<template>
  <p v-if="proposedDistances.length">
    <i18n-t keypath="try increase your search radius">
      <template #radius>
        <template v-for="distance in proposedDistances" :key="distance">
          <pu-low-results-search-link
            class="losenge"
            :modify-filters="{ within: distance }"
          >
            <translate :tt="{ value: distance }">
              {value, localeDistance, short}
            </translate>
          </pu-low-results-search-link>
        </template>
      </template>
      <template #yourLocation>
        <strong>{{ cityName }}</strong>
      </template>
    </i18n-t>
  </p>
</template>

<script lang="ts">
import type { Pinia } from 'pinia'
import {
  getCurrentRangeValue,
  getProposedDistances,
} from '~/utility/geo/distance-units'
import type { GeoCircle } from '~/utility/geo/GeoLocation'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  setup() {
    const searchStore = useSearchStoreSetup(usePinia() as Pinia)
    return { searchStore }
  },
})
class LowResultsCitySearch extends Vue {
  @Prop({ required: false })
  area?: GeoCircle

  @Prop({ required: true })
  cityName: string

  step = 5
  maxDistanceFromActualWithin = 20
  topDistanceLimit = 95

  get isKilometers() {
    return this.$i18n.localeInfo.distanceUnit === 'km'
  }

  get proposedDistances(): number[] {
    const currentRange = getCurrentRangeValue({
      searchStore: this.searchStore,
      isKilometers: this.isKilometers,
      area: this.area,
      defaultWithinRange: this.$config.public.defaultWithinRange,
    })

    return getProposedDistances({
      currentRange,
      step: this.step,
      maxDistanceFromCurrent: this.maxDistanceFromActualWithin,
      topLimit: this.topDistanceLimit,
      isKilometers: this.isKilometers,
    })
  }
}

export default toNative(LowResultsCitySearch)
</script>
